import { useEffect } from 'react'
import { useStore, useSelector } from 'react-redux'

import { updateCalAnonymousId } from 'actions/current_user'
import { getCalendlyAnonymousId, ensureCalendlyAnonymousId } from 'utils'
import { isCookiesAllowedSelector } from 'selectors/gdpr'
import { markVendorInitialized } from 'services/vendors/vendor_runtime'

let initialized = false

export const CalAnonymousId = ({ onInitialized }) => {
  const store = useStore()
  const isPerformanceConsent = useSelector(isCookiesAllowedSelector('performance'))

  useEffect(() => {
    // On consent change, ensure ID exists (creates if needed when consent granted)
    // Otherwise, just load existing ID from cookie (server-set or previously set)
    const id = isPerformanceConsent
      ? ensureCalendlyAnonymousId(isPerformanceConsent)
      : getCalendlyAnonymousId()

    if (id) {
      store.dispatch(updateCalAnonymousId(id))
      markVendorInitialized('calendly_anonymous_id')
    }

    // Signal ready after first check so page can render
    // Edge case: user without consent/cookie won't have an ID, but page still loads
    if (!initialized) {
      initialized = true
      if (onInitialized) {
        onInitialized()
      }
    }
  }, [store, onInitialized, isPerformanceConsent])

  return null
}
